{
    "apiKey": "aac9f485-1439-4164-8cd7-e42a1e204304",
    "noticeId": "qyYUYP6e",
    "sdkPath": "https://sdk.privacy-center.org/",
    "iabVersion": 2
}